/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Sentry.init({
  dsn: environment.sentry.dsn,
  environment: environment.sentry.environment,
  integrations: [
    // mide el rendimiento de las navegaciones y de las peticiones http
    Sentry.browserTracingIntegration(),
    // graba la sesión del usuario; Sentry por defecto enmascara todo el texto, los inputs y los medios,
    // aquí se desactiva el enmascarado para poder ver la sesión tal cual ocurrió
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false
    })
  ],
  tracesSampleRate: environment.sentry.tracesSampleRate,
  tracePropagationTargets: environment.sentry.tracePropagationTargets,
  replaysSessionSampleRate: environment.sentry.replaysSessionSampleRate,
  replaysOnErrorSampleRate: environment.sentry.replaysOnErrorSampleRate,
  // envía a Sentry los console.log/warn/error de la app
  enableLogs: true
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
